import React, { useEffect, useRef, useState } from "react";
import { Carousel, Typography } from "@material-tailwind/react";
import { Helmet } from "react-helmet";

const images = require.context("../../uploads/Photos/Our-Projects", false, /\.(webp|jpg|png|jpeg|JPG)$/);

const image_list = images.keys().map((imagePath) => images(imagePath).default || images(imagePath));

const image_headers = image_list.filter((image) => image.includes("HEADER") ? image : "");
const image_others = image_list.filter((image) => !image.includes("HEADER"));

export default function ComercialSolutions() {
    const [imageVisible, setImageVisible] = useState(false);
    const [isIos, setIsIos] = useState(false);
    const imageContainerRef = useRef(null);
    const [isVisible, setIsVisible] = useState(new Array(image_list).fill(false));
    const cardRefs = useRef(image_list.map(() => React.createRef()));
    
    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        const index = cardRefs.current.findIndex(
                            (ref) => ref.current === entry.target
                        );
                        if (index !== -1) {
                            setIsVisible((prev) => {
                                const newVisibility = [...prev];
                                newVisibility[index] = true;
                                return newVisibility;
                            });
                        }
                    }
                });
            },
            { threshold: 0.8 }
        );

        cardRefs.current.forEach((ref) => {
            if (ref.current) {
                observer.observe(ref.current);
            }
        });

        return () => {
            observer.disconnect();
        };
    }, [image_list.length]);

    const detectIos = () => {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        if (/iPad|iPhone|iPod/.test(userAgent)) {
            setIsIos(true);
        }
    };

    useEffect(() => {
        detectIos();
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('animate');
                        entry.target.classList.add('blur-none');
                        observer.unobserve(entry.target);
                    }
                });
            },
            { threshold: 0.8 }
        );

        if (imageContainerRef.current) {
            observer.observe(imageContainerRef.current);
        }

        return () => {
            if (imageContainerRef.current) {
                observer.unobserve(imageContainerRef.current);
            }
        };
    }, []);

    return (
        <>
            <Helmet>
                <title>EES | Наши Проекти</title>
                <meta name="title" content="Наши Проекти | Енергетска Ефикасност" />
                <meta name="description" content="Откријте ги нашите иновативни решенија за комерцијални згради, дизајнирани за енергетска ефикасност и одржливост." />
                <meta name="keywords" content="комерцијални решенија, енергетска ефикасност, одржливост, згради" />
            </Helmet>

            <div ref={imageContainerRef} id='image-container'>
                {/* Header Carousel */}
                <Carousel
                    autoplay={true}
                    autoplayDelay={6000}
                    loop={true}
                    className='h-5/6'
                    navigation={({ setActiveIndex, activeIndex, length }) => (
                        <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex gap-2 z-50">
                            {new Array(length).fill("").map((_, i) => (
                                <span
                                    key={i}
                                    className={`block h-1 cursor-pointer transition-all duration-300 rounded-md ${activeIndex === i ? "w-8 bg-white" : "w-4 bg-white/50"}`}
                                    onClick={() => setActiveIndex(i)}
                                />
                            ))}
                        </div>
                    )}
                >
                    {image_headers.map((image_url, index) => (
                        <div className="relative h-full w-full">
                            <img
                                src={image_url}
                                alt={`Slide ${index + 1}`}
                                className="h-full w-full object-cover"
                            />
                        </div>
                    ))}
                </Carousel>

                {/* Title for Projects */}
                <div className="px-6 mx-auto sm:max-w-xl md:max-w-full lg:max-w-[95%] xl:max-w-[90%] md:px-24 lg:px-8 mt-5 sm:mt-5 md:mt-10 lg:mt-7">
                    <Typography color="black" className="text-start text-xl sm:text-3xl md:text-4xl">
                        Наши Проекти
                    </Typography>
                </div>
            </div>

            {/* Image Carousel Below the Header */}
            <section className="p-10">
                <div className="w-full flex flex-col md:flex-row items-center">
                    {/* Carousel Section */}
                    <div className="w-full md:w-[50%] rounded-lg overflow-hidden shadow-lg mb-8 md:mb-0">
                        <Carousel
                        autoplay={true}
                        autoplayDelay={5000}
                        loop={true}
                        className="h-80"
                        navigation={({ setActiveIndex, activeIndex, length }) => (
                            <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex gap-2 z-50">
                            {new Array(length).fill("").map((_, i) => (
                                <span
                                key={i}
                                className={`block h-1 cursor-pointer transition-all duration-300 rounded-md ${
                                    activeIndex === i ? "w-8 bg-white" : "w-4 bg-white/50"
                                }`}
                                onClick={() => setActiveIndex(i)}
                                />
                            ))}
                            </div>
                        )}
                        >
                        {image_others.map((image_url, index) => (
                            <div className="relative h-full w-full">
                            <img
                                src={image_url}
                                alt={`Slide ${index + 1}`}
                                className="h-full w-full object-cover"
                            />
                            </div>
                        ))}
                        </Carousel>
                    </div>

                    {/* Text Section */}
                    <div className="w-full md:w-[30%] md:ml-10 text-center md:text-left">
                        <h2 className="text-2xl font-bold mb-4">RENAULT</h2>
                    </div>
                    </div>
            </section>

        </>
    );
}
